import { InnerContentItem } from "@certn/cascadia-react";
import { usePeopleAPI } from "@certn/legacy-api";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { useTranslation } from "react-i18next";

import { useCountryName } from "../../../../components/AddressInput";

export function AustraliaRightToWorkSummaryField({
  field: config,
}: {
  field: components["schemas"]["AustraliaRightToWorkCheckField"];
}) {
  const { t } = useTranslation();
  const getCountryName = useCountryName();

  const { data: categoryTypes } = usePeopleAPI<
    "/internal/people/document-types/",
    Record<
      "australian_citizen" | "non_australian_citizen",
      { key: string; value: string }[]
    >
  >("/internal/people/document-types/", {
    check: "rtw",
  });

  const isAUCitizen = config.value?.document_issuing_country === "AU";

  return (
    <>
      <InnerContentItem
        label={t("Documentation")}
        testID="aus-rtw-summary-documentation"
      >
        {categoryTypes?.[
          isAUCitizen ? "australian_citizen" : "non_australian_citizen"
        ]?.find(({ key }) => key === config.value?.document_type)?.value ?? "-"}
      </InnerContentItem>

      {!isAUCitizen && (
        <InnerContentItem
          label={t("Issuing country")}
          testID="non-aus-rtw-summary-documentation"
        >
          {config.value?.document_issuing_country
            ? getCountryName(config.value.document_issuing_country)
            : "-"}
        </InnerContentItem>
      )}

      <InnerContentItem
        label={t("Document number")}
        testID="aus-rtw-summary-document-number"
      >
        {config.value?.document_number ?? "-"}
      </InnerContentItem>
    </>
  );
}
